import Vue from 'vue';
import Vuex from 'vuex';
import app from './app/';

import AccountingStore, {
  AccountingStoreNamespace,
} from '../modules/accounting/store/index';
import DistributionStore, {
  DistributionStoreNamespace,
} from '../modules/distribution/store/index';
import BookingStore, {
  BookingStoreNamespace,
} from '../modules/booking/store/index';
import RoyaltyStore, {
  RoyaltyStoreNamespace,
} from '../modules/royalty/store/index';
import B2BStore, {
  B2BStoreNamespace,
} from '../modules/b2b/store/index';

import ContactStore, {
  ContactStoreNamespace,
} from '../modules/contacts/store/index';

import SettingsStore, {
  SettingsStoreNamespace,
} from '../modules/settings/store/index';
import LabelStore, { CatalogStoreNamespace } from '../modules/catalog/store';
import LicenceStore, { LicenceStoreNamespace } from '../modules/licensing/store';
import TaskStore ,{ TaskStoreNamespace } from '../modules/tasks/store';
import DTGPTStore ,{ DTGPTStoreNamespace } from '../modules/to-be-deleted/store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    [AccountingStoreNamespace]: AccountingStore,
    [BookingStoreNamespace]: BookingStore,
    [B2BStoreNamespace]: B2BStore,
    [ContactStoreNamespace]: ContactStore,
    [SettingsStoreNamespace]: SettingsStore,
    [DistributionStoreNamespace]: DistributionStore,
    [CatalogStoreNamespace]: LabelStore,
    [RoyaltyStoreNamespace]: RoyaltyStore,
    [LicenceStoreNamespace]: LicenceStore,
    [TaskStoreNamespace]:TaskStore,
    [DTGPTStoreNamespace]:DTGPTStore
  },
});




// TODO: Remove ramda export to windows in production build

// window.R = R;
// window.RA = RA;
// window.S = S;
// window.D = D;
